import React from "react";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import ITRequestPage from "../itsupport/ITRequestPage";

export default function EmployeeITSupportPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <EmployeeNavbar />
      <ITRequestPage />
    </div>
  );
}
